import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDbIcMail32 = (props) => /* @__PURE__ */ _jsx("svg", {
	id: "icon",
	height: 32,
	viewBox: "0 0 32 32",
	width: 32,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "m28 6c1.094 0 2 .906 2 2v15a3 3 0 0 1 -3 3h-22a3 3 0 0 1 -3-3v-15c0-1.094.906-2 2-2zm0 3.406-9.875 9.875a3.005 3.005 0 0 1 -2.125.875c-.719 0-1.438-.218-1.969-.75l-10.031-10v13.594c0 .563.438 1 1 1h22c.563 0 1-.438 1-1zm-1.406-1.406h-21.188l9.875 9.875a.961.961 0 0 0 .719.281c.219 0 .531-.093.75-.312z",
		fill: "var(--db-icon-color, currentColor)",
		fillRule: "evenodd"
	})
});
export default SvgDbIcMail32;
